<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <!-- <Datatable
      :key="key"
      :data-array="dataTable"
      :data-array-table="dataArrayTable"
      id="volunteer-table"
      data-test="volunteer-table"
      :total-list="dataTable.length"
      :pagination-size="10"
    /> -->
    <VTDatatable
      :key="key"
      :data-array="dataTable"
      :data-array-table="dataArrayTable"
      id="volunteer-table"
      data-test="volunteer-table"
    />
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, watch } from "vue";
import VTDatatable from "@/components/datatable/datatableProfile.vue";
import axios from "axios";
import store from "@/store";

export default defineComponent({
  components: {
    VTDatatable,
  },
  props:{
    reloadTable:{
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    /*
    const dataArray = [
      {
        _id: "1",
        cm_id: "1",
        cm_uid: "cm990001",
        uid: "vt990001",
        title: "นางสาว",
        name: "สมศรี",
        surname: "สุขใจ",
        national_id: "1234567890123",
        tel_num: "0819999999",
      },
      {
        _id: "2",
        cm_id: "1",
        cm_uid: "cm990001",
        uid: "vt990002",
        title: "นาย",
        name: "สมหมาย",
        surname: "รักชาติ",
        national_id: "1234567890124",
        tel_num: "0818888888",
      },
      {
        _id: "3",
        cm_id: "1",
        cm_uid: "cm990001",
        uid: "vt990003",
        title: "นาง",
        name: "สมใจ",
        surname: "รักชาติ",
        national_id: "1234567890125",
        tel_num: "0819990987",
      },
    ];
    */

    const dataTable = ref([]);
    const key = ref(1);

    onMounted(async () => {
      getDatatable();
      console.log(dataTable);
    });

    const getDatatable = async () => {
      const url = `${process.env.VUE_APP_BASE_API}volunteer/getVolunteer`;
      console.log(url);
      const res = await axios.post(url, {
        cm_uid: store.getters["userAuth/getUsername"],
      });

      if (res.status === 200) {
        dataTable.value = res.data;
        key.value++;
      }
    };

    var customNameMutator = (value, data, type, params, component) => {
      return `${data.title}${data.name} ${data.surname}`;
    };
    const dataArrayTable = reactive([
      {
        title: "เลขบัตรประจำตัวประชาชน",
        field: "national_id",
        hozAlign: "center",
        minWidth: 200,
        resizableRows: true,
      },
      {
        title: "ชื่อ - สกุล",
        field: "name",
        hozAlign: "center",
        minWidth: 200,
        widthGrow: 1,
        style: "padding: 12px 10px;",
        mutator: customNameMutator,
        resizableRows: true,
      },
      {
        title: "เบอร์โทรศัพท์",
        field: "tel_num",
        hozAlign: "center",
        minWidth: 200,
        widthGrow: 1,
        resizableRows: true,
      },
    ]);
    watch(()=>props.reloadTable,(val)=>{
      if(val){
        getDatatable()
      }
    })

    return {
      dataTable,
      key,
      dataArrayTable,
    };
  },
});
</script>
<style>
/* #volunteer-table.tabulator .tabulator-header .tabulator-headers .tabulator-col .tabulator-col-content{
padding: 12px !important;
align-content:left;
} */
.tabulator-cell[tabulator-field="national_id"] {
  font-weight: 600;
}
</style>

